// src/store/api/selectors.js
import { createSelector } from '@reduxjs/toolkit'

import { EMPTY_ARRAY, EMPTY_SESSION, RECORDING_STATUS, SESSION_STATUS } from '~/lib/constants'
import { selectSettings } from '~/store/settings/selectors'

export const selectApi = s => s.api

export const selectQueries = s => s.api.queries

export const selectProjects = s => s.api.queries['getProjects(undefined)']?.data || EMPTY_ARRAY

// const EMPTY_CREDITS = { amount: 0 }

export const selectCredits = s => s.api.queries['getCredits(undefined)']?.data || 0

export const selectSession = createSelector(selectQueries, q => q['getActiveSession(undefined)']?.data || EMPTY_SESSION)

export const selectSessionStatus = createSelector(selectSession, session => session.status)

export const selectSessionId = createSelector(selectSession, session => session.id)

export const selectSessionTimestamp = createSelector(selectSession, session => session.statusTimestamp)

export const selectSessionPhase = createSelector(selectSession, session => session.phase || null)

// The running session's actual type, else the launch preference. `settings.session_type` is reset to the default on every page load (`store/settings`), so after a reload it no longer names the session that is running.
export const selectSessionType = createSelector(selectSession, selectSettings, (session, settings) =>
	session.status !== SESSION_STATUS.IDLE && session.type ? session.type : settings.session_type
)

// Recordings selectors
export const selectRecordingsData = s => s.api.queries['getRecordings(undefined)']?.data || EMPTY_ARRAY

export const selectActiveRecording = createSelector(
	[selectRecordingsData, selectSessionId],
	(recordings, currentSessionId) => {
		// No session = no active recording (stale STARTED recordings are ignored)
		if (!currentSessionId) return null

		// Only this session's STARTED recording counts as active
		return recordings.find(r => r.sessionId === currentSessionId && r.status === RECORDING_STATUS.STARTED) || null
	}
)

export const selectIsRecording = createSelector([selectActiveRecording], activeRecording => !!activeRecording)
